import { auth } from "~/services/auth.server";
import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { json, useLoaderData } from "@remix-run/react";
import Header from "~/components/Header";
import HeroSection from "./components/HeroSection";
import UseCaseSection1 from "./components/UseCaseSection1";
import UseCaseSection2 from "./components/UseCaseSection2";
import HowItWorksSection from "./components/HowItWorksSection";
import CallToActionSection from "./components/CallToActionSection";
import WhyKnackSheetSection from "./components/WhyKnackSheetSection";
import FeatureComparisonSection from "./components/FeatureComparisonSection";

export const meta: MetaFunction = () => {
  return [
    { title: "Low Code Plugins" },
    {
      name: "description",
      content: "Supercharge your Knack app with Low Code Plugins.",
    },
    {
      property: "og:image",
      content: "/site-preview.png",
    },
  ];
};

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const user = await auth.isAuthenticated(request);
  return json({ isLoggedIn: !!user });
};

export default function HomePage() {
  const { isLoggedIn } = useLoaderData<typeof loader>();

  return (
    <>
      <Header isLoggedIn={isLoggedIn} />
      <main>
        <HeroSection />
        <div className="flex flex-col gap-32 py-8 md:py-16">
          <UseCaseSection1 />
          <UseCaseSection2 />
          <HowItWorksSection />
          <CallToActionSection />
          <WhyKnackSheetSection />
          <FeatureComparisonSection />
          <CallToActionSection />
        </div>
      </main>
    </>
  );
}
